import React, { useEffect, useMemo, useState } from "react";
import FTTag from "../../../../stories/common/ft-tag";
import { FlipperVaultCardProps } from "../../../../stories/common/flipper-vault-card";
import moment from "moment";
import VaultTag from "../../../../stories/common/vault-tag";
import Timer from "../../../../stories/common/timer";
import AvatarC from "../../../../stories/common/avatar";
import AddressSection from "./address-section";
import CheckoutBtn from "../../../../stories/common/flipper-vault-card/checkoutButton";
// import ReleaseBtn from "../../../../stories/common/flipper-vault-card/releaseButton";
import ContactWeb from "./contact-web";
import { PurchaseHistoryViewed } from "../../../../utils/inv-exch-amplitude";
import { useSearchParams } from "react-router-dom";
import AddToCalling from "../../../../stories/common/add-to-calling";
// import { Tooltip } from "primereact/tooltip"; // DND cooldown tooltip disabled

export default function ListRow({
  account,
  Address,
  setShowAddress,
  setMostVisibleCard,
  styles
}: {
  account: FlipperVaultCardProps;
  Address: string;
  setShowAddress: (address: string) => void;
  setMostVisibleCard: any;
  styles: any;
}) {
  const [showReleaseBtn, setShowReleaseBtn] = React.useState(
    account?.checkouts?.[account?.checkouts?.length - 1]?.createdAt &&
      -moment
        .utc(account?.checkouts?.[account?.checkouts?.length - 1]?.createdAt)
        .diff(moment().utc(), "minutes") <=
        +`${process.env.REACT_APP_RELEASE_TIMER}`
      ? true
      : false
  );
  const [isExpired, setIsExpired] = React.useState(
    moment
      .utc(account?.checkouts?.[account?.checkouts?.length - 1]?.expirtyAt)
      .isBefore(moment().utc())
  );
  const userDetail = useMemo(() => {
    const userObj = localStorage.getItem("user-detail");
    return userObj ? JSON.parse(userObj) : null;
  }, []);

  // Cooldown countdown — DND disabled for now
  // const [cooldownText, setCooldownText] = useState<string>("");
  // const [isCooldownActive, setIsCooldownActive] = useState<boolean>(() => {
  //   if (!account?.isCooldown || !account?.cooldownExpireAt) {
  //     return false;
  //   }
  //   const target = moment.utc(account?.cooldownExpireAt);
  //   return target.isValid() && target.isAfter(moment.utc());
  // });
  // const isCooldownActive = false; // DND disabled

  // useEffect(() => {
  //   if (!account?.isCooldown || !account?.cooldownExpireAt) {
  //     setCooldownText("");
  //     setIsCooldownActive(false);
  //     return;
  //   }
  //
  //   const target = moment.utc(account?.cooldownExpireAt);
  //   if (!target.isValid()) {
  //     setCooldownText("");
  //     setIsCooldownActive(false);
  //     return;
  //   }
  //
  //   const update = () => {
  //     const now = moment.utc();
  //     const diffMs = target.diff(now);
  //     if (diffMs <= 0) {
  //       setCooldownText("");
  //       setIsCooldownActive(false);
  //       return false;
  //     }
  //     setIsCooldownActive(true);
  //     const duration = moment.duration(diffMs);
  //     const totalDays = Math.floor(duration.asDays());
  //     const totalHours = Math.floor(duration.asHours());
  //     const totalMinutes = Math.floor(duration.asMinutes());
  //     const totalSeconds = Math.floor(duration.asSeconds());
  //
  //     if (totalDays >= 1) {
  //       setCooldownText(
  //         `${totalDays} ${totalDays === 1 ? "Day" : "Days"} Left`
  //       );
  //     } else if (totalHours >= 1) {
  //       setCooldownText(
  //         `${totalHours} ${totalHours === 1 ? "Hour" : "Hours"} Left`
  //       );
  //     } else if (totalMinutes >= 1) {
  //       setCooldownText(
  //         `${totalMinutes} ${totalMinutes === 1 ? "Min" : "Mins"} Left`
  //       );
  //     } else {
  //       setCooldownText(
  //         `${Math.max(totalSeconds, 0)} ${
  //           totalSeconds === 1 ? "Sec" : "Secs"
  //         } Left`
  //       );
  //     }
  //     return true;
  //   };
  //
  //   update();
  //   const id = setInterval(() => {
  //     if (!update()) {
  //       clearInterval(id);
  //     }
  //   }, 1000);
  //   return () => clearInterval(id);
  // }, [account?.isCooldown, account?.cooldownExpireAt]);

  const hideInfo = useMemo(() => {
    return (
      account?.owner?.[0]?.id !== userDetail?.id &&
      account?.vaultOwnerId !== userDetail?.id &&
      (isExpired ||
        account?.checkouts?.[account?.checkouts?.length - 1]?.releasedAt !==
          null)
    );
  }, [account?.vaultOwnerId, userDetail?.id, isExpired, account?.checkouts]);

  const getVaultStatus = (account: FlipperVaultCardProps) => {
    const { checkouts, owner, vaultOwnerId, bidCount } = account;
    const lastCheckout = checkouts?.[checkouts?.length - 1];
    if (vaultOwnerId !== null) {
      if (vaultOwnerId === userDetail?.id) {
        // show My Vault
        return "MY VAULT";
      } else {
        if (lastCheckout?.userId === userDetail?.id) {
          if (isExpired) {
            return "EXPIRED";
          } else {
            if (bidCount && bidCount > 0) {
              return "BID PLACE";
            } else {
              return "CHECKED OUT";
            }
          }
        } else {
          return "LOCKED";
        }
      }
    } else {
      if (owner?.[0].id === userDetail?.id) {
        // owner and watching my account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            // have release data
            // show release by user Name in bottom bar and status will release
            return "RELEASED";
          } else if (isExpired) {
            // last checkout release date is null
            // check for expired condition
            // show expired by user name and status expired
            if (bidCount && bidCount > 0) {
              return "BID PLACED";
            } else {
              return "EXPIRED";
            }
          } else {
            // show checked out by user name and timer in bottom bar and status will by checked out
            if (bidCount && bidCount > 0) {
              return "BID PLACED";
            } else {
              return "CHECKED OUT";
            }
          }
        } else {
          // show nothing in bottom bar status also null
          if (bidCount && bidCount > 0) {
            return "BID PLACE";
          } else {
            return null;
          }
        }
      } else {
        // not owner and watching other's account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            if (lastCheckout?.userId === userDetail?.id) {
              // checked out by me and released
              return "RELEASED";
            } else {
              // not checked out by me and released by other
              // can see checkout button
              if (account?.hasCheckedOutByMe === "1") {
                return "CHECK OUT";
              }
              return null;
            }
          } else if (isExpired) {
            // release date is null
            // is expired
            if (lastCheckout?.userId === userDetail?.id) {
              // checked out by me and expired by me
              // show expiredd
              if (bidCount && bidCount > 0) {
                return "BID PLACED";
              } else {
                return "EXPIRED";
              }
            } else {
              // show Locked
              return "CHECK OUT";
            }
          } else {
            if (lastCheckout?.userId === userDetail?.id) {
              // show release button and timer
              if (bidCount && bidCount > 0) {
                return "BID PLACE";
              } else {
                return "CHECKED OUT";
              }
            } else {
              // show Locked
              if (bidCount && bidCount > 0) {
                return "BID PLACED";
              } else {
                return "CHECK OUT";
              }
            }
          }
        } else {
          if (bidCount && bidCount > 0) {
            return "BID PLACED";
          } else {
            return null;
          }
        }
      }
    }
  };
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get("pid") || "";
  const pubPropertySfid = searchParams.get("sfid") || "";
  return (
    <>
      <tr key={account.acctId}>
        <td className={styles.arrow}>
          <img
            onClick={(e) => {
              if (
                getVaultStatus(account) === "CHECKED OUT" ||
                getVaultStatus(account) === "MY VAULT" ||
                getVaultStatus(account) === "BID PLACE" ||
                account?.owner?.[0]?.id === userDetail?.id
              ) {
                PurchaseHistoryViewed({
                  property_id: propertyId,
                  investor_id: account?.acctId,
                  property_sfid: pubPropertySfid,
                  investor_sfid: account?.acctSfid
                });
                e.preventDefault();
                setMostVisibleCard(account.acctId);
                setShowAddress(
                  Address === account.acctId ? "" : account.acctId
                );
              }
            }}
            src={`/images/${
              Address === account.acctId
                ? "arrow-down.svg"
                : "flipper-list-web-left-arrow.svg"
            }`}
            alt="arrow-down.svg"
            className={
              getVaultStatus(account) === "CHECKED OUT" ||
              getVaultStatus(account) === "MY VAULT" ||
              getVaultStatus(account) === "BID PLACE" ||
              account?.owner?.[0]?.id === userDetail?.id
                ? ""
                : styles.Blur
            }
          />
        </td>
        <td
          className={`${styles.accountName} ${
            (getVaultStatus(account) === "CHECK OUT" ||
              getVaultStatus(account) === "LOCKED" ||
              getVaultStatus(account) === "BID PLACED") &&
            styles.Blur
          }`}
        >
          {account.acctName}
          <div className={styles.statusWrap}>
            <FTTag
              status={account?.investorStatus}
              className={
                getVaultStatus(account) === "LOCKED" ||
                getVaultStatus(account) === "CHECK OUT" ||
                getVaultStatus(account) === "BID PLACED" ||
                hideInfo
                  ? "blur"
                  : ""
              }
            />
          </div>
        </td>
        <td className={styles.contacts}>
          {!hideInfo &&
          getVaultStatus(account) !== "LOCKED" &&
          getVaultStatus(account) !== "BID PLACED" &&
          getVaultStatus(account) !== "CHECK OUT" ? (
            <ContactWeb account={account} />
          ) : (
            "-"
          )}
        </td>
        <td
          className={`${styles.interestScore} ${
            account?.interestScore >= 50
              ? styles.Green
              : account?.interestScore >= 30
              ? styles.Yellow
              : styles.Red
          }`}
        >
          {account?.interestScore || 0}
        </td>
        <td className={`${styles.interestScore}`}>
          {account?.emailScore || 0}
        </td>
        <td>
          <VaultTag
            isWhite={
              getVaultStatus(account) === "LOCKED" ||
              getVaultStatus(account) === "BID PLACED"
            }
            status={getVaultStatus(account)}
            isLocked={
              getVaultStatus(account) === "MY VAULT" ||
              getVaultStatus(account) === "LOCKED" ||
              getVaultStatus(account) === "BID PLACED"
            }
          />
          {/* DND / cooldown UI disabled for now
          {isCooldownActive && (
            <>
              <div className={`${styles.coolDown}`} id={`coolDown-${account?.acctId}`}>
                <img src="/images/cooldown-icon.svg" alt="" width={12} />
                COOLDOWN
              </div>
              <Tooltip
                content={`${cooldownText}`}
                target={`#coolDown-${account?.acctId}`}
                className={styles.tooltipCoolDown}
              />
            </>
          )}
          */}
        </td>
        <td className={styles.timerWrapper}>
          {account?.checkouts?.length > 0 &&
          (getVaultStatus(account) === "CHECKED OUT" ||
            getVaultStatus(account) === "BID PLACE") ? (
            <Timer
              setShowReleaseBtn={setShowReleaseBtn}
              className={styles.timer}
              type="web"
              classNameClock={styles.timerClock}
              ShowTitle={false}
              textColor={"Black"}
              acctId={account?.acctId}
              createdAt={
                account?.checkouts[account?.checkouts?.length - 1]?.createdAt
              }
              time={
                account?.checkouts[account?.checkouts?.length - 1]?.expirtyAt
              }
              onExpire={() => setIsExpired(true)}
            />
          ) : getVaultStatus(account) !== "MY VAULT" &&
            getVaultStatus(account) !== "LOCKED" &&
            getVaultStatus(account) !== "EXPIRED" &&
            getVaultStatus(account) !== "RELEASED" &&
            getVaultStatus(account) !== "CHECKED OUT" &&
            getVaultStatus(account) !== "CHECK OUT" &&
            getVaultStatus(account) !== "BID PLACED" &&
            account?.bidCount < 1 ? (
            <CheckoutBtn
              isCoolDownActive={false /* isCooldownActive — DND disabled */}
              acctId={account?.acctId}
              setHideInfo={() => {}}
              isExpired={isExpired}
              flipperData={account}
              type={"web"}
            />
          ) : (
            "-"
          )}
        </td>
        <td>
          <AvatarC
            className={styles.avatar}
            size="normal"
            shape="circle"
            label={`${
              `${account?.owner?.[0].name
                .split(" ")[0]
                .charAt(0)}${account?.owner?.[0].name
                .split(" ")[1]
                .charAt(0)}` || "N/A"
            }`}
          />
        </td>
        {getVaultStatus(account) === "MY VAULT" &&
          !account?.isInCallingPipeline && (
            <div className={styles.AddToCallingPipeline}>
              <AddToCalling
                accountId={account?.acctId}
                pubPropertyId={propertyId}
              />
            </div>
          )}
      </tr>
      {Address === account.acctId && (
        <tr>
          <td colSpan={9}>
            <AddressSection account={account} />
          </td>
        </tr>
      )}
    </>
  );
}
